import { AxiosError } from 'axios';

export default (err: AxiosError | Error) => {
  if (!err) {
    return null;
  }
  const errorData = (err as AxiosError).response?.data;
  const message = (errorData && (errorData.message || errorData)) || err.message;

  return {
    status: (err as AxiosError).response?.status,
    message:
      typeof message === 'object' ? message.error?.message || message.error || message : message,
  };
};
